import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../utils/localStorage";
import { getBrandStore } from "../services/StoreUsers/PostStoreUsers";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const SelectStoreInAdmin = ({
  setSearchStoreModalMenuVisible,
  searchStoreModalMenuVisible,
  sendDataToAdminDashboard,
  refreshDashboard,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [storeUserData, setStoreUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // New state for loading indicator
  const [selectedItem, setSelectedItem] = useState(null); // Track selected item

  const navigate = useNavigate();
  const { brandProfileData } = getUserData();

  const brandId = brandProfileData.id;

  const fetchStoreUser = () => {
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreUserData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreUser();
  }, []);

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const filterUserList = () => {
    return storeUserData.filter((item) => {
      const fullName = item.storeName?.toLowerCase();
      const matchesSearchTerm = fullName?.includes(searchTerm.toLowerCase());
      return matchesSearchTerm;
    });
  };

  const filteredUserData = filterUserList();

  // function for submit and call naviation to customerInfo Page with storeCustomerId
  const handleItemPress = (item) => {
    setSelectedItem(item.id);
    setIsLoading(true);
    setTimeout(async () => {
      setIsLoading(false);
      setSelectedItem(null);
      sendDataToAdminDashboard({
        storeInfo: item,
      });
      setSearchStoreModalMenuVisible(false);
      setSearchTerm("");
    }, 1000); // Replace with actual async operation duration
  };

  const handleALLItemPress = () => {
    setSearchStoreModalMenuVisible(false);
    refreshDashboard({
      success: true,
    });
  };

  const handleModalClose = () => {
    setSearchStoreModalMenuVisible(!searchStoreModalMenuVisible);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={searchStoreModalMenuVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!searchStoreModalMenuVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div className="flex-1">
            <div
              className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
              style={{
                "--surface-0": "#1752AA",
              }}
            >
              <div className="flex-1 flex ml-3 mr-3">
                <div className="flex-1 flex ">
                  <div className="flex-1 ml-5">
                    <InputText
                      value={searchTerm}
                      placeholder={"Search Store"}
                      style={{
                        width: "90%",
                        backgroundColor: "transparent",
                        borderColor: "transparent",
                        border: "none",
                        color: "#fff",
                        fontSize: 20,
                        fontWeight: "500",
                      }}
                      className="customer-placeholder"
                      autoFocus={true}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                      }}
                    />
                  </div>
                  <Button
                    label="x"
                    onClick={(e) => hide(e)}
                    text
                    className=" text-2xl text-primary-50 "
                  ></Button>
                </div>
              </div>
            </div>

            <div
              className=" surface-0"
              style={{
                "--surface-0": "#fff",
              }}
            >
              <div
                className="surface-0  pl-4 py-2 border-bottom-1"
                style={{
                  "--border-radius": "50px",
                  "--surface-0": "#F1F7FF",
                  borderBottomColor: "#D2DBD6",
                }}
              >
                <p className="text-xl font-medium">Search Results</p>
              </div>
              <div>
                <div
                  className="px-5 py-2 border-round-md border-bottom-1 flex justify-content-between"
                  style={{
                    borderBottomColor: "#D2DBD6",
                    cursor: "pointer",
                  }}
                  onClick={() => handleALLItemPress()}
                >
                  <div>
                    <p
                      className="text-color text-lg font-normal uppercase"
                      style={{
                        "--text-color": "#75879B",
                      }}
                    >
                      All Store
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="h-20rem scroll-bar mb-2"
                style={{
                  overflowY: "scroll",
                }}
              >
                {filteredUserData?.map((item) => (
                  <div
                    key={item.mobile}
                    className="px-5 py-2 border-round-md border-bottom-1 flex justify-content-between"
                    style={{
                      borderBottomColor: "#D2DBD6",
                      cursor: "pointer",
                    }}
                    onClick={() => handleItemPress(item)}
                  >
                    <p
                      className="text-color text-lg font-normal uppercase"
                      style={{
                        "--text-color": "#75879B",
                      }}
                    >
                      {item.storeName}
                    </p>
                    {selectedItem === item.id && (
                      <div className="flex align-self-center">
                        <i
                          className="pi pi-check"
                          style={{ fontSize: "20px", color: "#008EFF" }}
                        ></i>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default SelectStoreInAdmin;
